module.exports = __webpack_public_path__ + "img/weixin.183ff9a5.png";